<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <el-input class="search_input search_inputBox" v-model="params.keyword" placeholder="公司名称/联系电话" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.purchaser_id" multiple collapse-tags placeholder="所属人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.province_id" placeholder="省份" size="mini" @change="searchChangePro">
                    <el-option v-for="pro in proList" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.city_id" placeholder="城市" size="mini">
                    <el-option v-for="city in searchCityList" :key="city.id" :value="city.id" :label="city.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.main_business" placeholder="主营项目" size="mini"></el-input>
                <div class="reset fcolor" @click="resetSearch">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" v-if="module.indexOf(',customer-export,')!=-1" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',supplier-edit,')!=-1" @click="dialogVisible = !dialogVisible;updataType=2">新增供应商</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="supplier.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getTableEdit="edit" @getTableDelete="del" @statusClick="statusClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="supplier.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 添加|修改 供应商 START -->
        <el-dialog v-dialog-drag :title="updataType==2?'添加供应商':'修改供应商'" class="eldialog eldialogA" :model="false" custom-class="full_dialog" :visible.sync="dialogVisible" width="630px" >
            <div class="clearfix">
                <el-form :model="form_params" :rules="rules" ref="edit_form">
                    <div class="eldialogFormBox">
                        <el-form-item label="供应商：" prop="name">
                            <el-input class="edit_input" v-model="form_params.name" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="联系人：" prop="linkman">
                            <el-input class="edit_input" v-model="form_params.linkman" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="phone">
                            <el-input class="edit_input" v-model="form_params.phone" placeholder=""></el-input>
                        </el-form-item>
                         <!-- <el-form-item label="所在省份：" prop="province_id">
                            <el-select class="edit_input" v-model="form_params.province_id" @change="changePro">
                                <el-option v-for="pro in proList" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="主营项目：" prop="main_business">
                            <el-input class="edit_input" v-model="form_params.main_business" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox">
                        <!-- <el-form-item label="公司地址：" prop="address">
                            <el-input class="edit_input" v-model="form_params.address" placeholder=""></el-input>
                        </el-form-item> -->
                        <el-form-item label="采购员：" prop="purchaser_id">
                            <el-select class="edit_input" v-model="form_params.purchaser_id" @visible-change="getSelectList('user')">
                                <el-option v-for="sale in selectMap.user" :key="sale.id" :value="sale.id" :label="sale.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电子邮箱：" prop="email">
                            <el-input class="edit_input" v-model="form_params.email" placeholder=""></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="所在城市：" prop="city_id">
                            <el-select class="edit_input" v-model="form_params.city_id">
                                <el-option v-for="city in cityList" :key="city.id" :value="city.id" :label="city.name"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="备注：" prop="remark">
                            <el-input class="edit_input" v-model="form_params.remark" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="addSupplier">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 添加|修改 供应商 END -->
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
        }
        .table_path{ flex: 1; }
        // dialog
        .dialog_hr{ position: absolute; left: 10px; right: 10px; top: 56px; margin: 0; }
        .edit_form{
            display: flex; align-items: center;
            & > div{ flex: 1; }
            .edit_input{ width: 160px; }
        }
    }
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                ruleForm:{
                    ids:[],
                    salesman_id:""
                },
                params:{
                    keyword: "",
                    purchaser_id:[],
                    province_id: "",
                    city_id: "",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    user:[],
                },
                // dialog
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                form_params : {
                    name:"",
                    purchaser_id:"",
                    linkman:"",
                    phone:"",
                    address:"",
                    province_id:"",
                    city_id:"",
                    email:"",
                    main_business:"",
                    remark:""
                },
                rules: {
                    name : [ { required: true, message: '请输入供应商', trigger: 'blur' } ],
                    // purchaser_id : [ { required: true, message: '请选择归属人', trigger: 'blur' } ],
                    // linkman : [ { required: true, message: '请输入联系人', trigger: 'blur' } ],
                    // phone : [ {required: true,  message: '请输入联系电话', trigger: 'blur' } ]
                },
               tableCol:[	
                    {colName:"状态",colKey:"status_label",isEdit:true,isDelete:true,isStatus:true},
                    {colName:"供应商",colKey:"name",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"省份",colKey:"province_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"城市",colKey:"city_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"联系电话",colKey:"phone",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购员",colKey:"purchaser_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系人",colKey:"linkman",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系电话",colKey:"phone",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"电子邮箱",colKey:"email",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"主营业务",colKey:"main_business",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"录入时间",colKey:"create_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ]
            }
        },
        created(){
            this.getSelectList("user")
            this.getArea().then(resolve=>{
                this.proList=resolve.data.data;
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            filterConfirm(){
                this.getList()
            },
            exportExcelBill(){
                this.$exportExecl("erp/supplier.export","供应商",this.params)
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/supplier.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            statusClick(data){      
                data.status = Number(data.status) === 1 ? 0 : 1;
                this.postFunc("erp/supplier.status",data,()=>{
                    this.getList()
                })
            },
            edit(id){
                this.dialogVisible=true;
                this.updataType=3;
                this.list.forEach(item=>{
                    if(item.id==id){
                        let editList=JSON.parse(JSON.stringify(item));
                        if(item.province_id!=0){
                            this.getArea(item.province_id).then(res=>{
                                this.cityList=res.data.data;
                            })
                        }
                        this.form_params=editList;
                        this.form_params = this.clearZero(this.form_params)
                    }
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.$postColumnList("/erp/supplier.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.list.forEach((item,ind)=>{
                        if(item.create_time){
                            this.list[ind].create_time = this.formatTime(this.list[ind].create_time+"000")
                            if(localStorage.dw_erp_power_code){
                                if(localStorage.dw_erp_power_code.indexOf(",supplier-edit,")!=-1){
                                    item.isEdit=true;
                                    item.isDelete=true;
                                }
                                // if(localStorage.dw_erp_power_code.indexOf(",supplier-del,")!=-1){
                                // }
                            }
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            searchChangePro(val){
                this.getArea(val).then(resolve=>{
                    this.searchCityList=resolve.data.data;
                    this.params.city_id="";
                })
            },
            changePro(val){
                this.getArea(val).then(resolve=>{
                    this.cityList=resolve.data.data;
                    this.form_params.city_id="";
                })
            },
            resetSearch(){
                this.params={keyword: "",purchaser_id:[],province_id: "",city_id: "",per_page: 50,page:1}
                this.getList()
            },
            addSupplier(){
                this.$refs["edit_form"].validate((valid) => {
					if (valid) {
                        if(this.updataType==2){
                            this.postFuncLoading("/erp/supplier.create",this.form_params,()=>{
                                this.tip("添加成功","success");
                                this.resetSearch();
                                this.form_params = this.resetJson(this.form_params)
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }else{
                            this.postFuncLoading("/erp/supplier.update",this.form_params,()=>{
                                this.tip("修改成功","success")
                                this.resetSearch();
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }
					} else {
						return false;
					}
				});
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
